import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.copyright.produced': '保留所有权利 | ZPayment.io',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...component,
  'page.dashboard.title': '主页',
  'page.notFound.title': '404',
  'page.notFound.subTitle': '抱歉，您访问的页面不存在',
  'page.notFound.button': '返回首页',
  'page.500.title': '500',
  'page.500.subTitle': '抱歉，出现了一些问题！请稍后再试。',
  'page.retry.button': '重试',
};
